import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML(레거시 문서 포함)이 모두 th 라 본문 칸만 일반 글자로 되돌림. 칸 색은 인라인 style */
export const SapContractFeeRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 900,
    textAlign: 'center',
  },
  '& table th, & table td': {
    whiteSpace: 'nowrap',
  },
  '& tbody th': {
    fontWeight: 400,
    backgroundColor: 'var(--dk-bg, #FFF)',
  },
  '& tbody td': {
    textAlign: 'center',
  },
}));
